import type { Form } from 'payments-lib-types';
import type { FC } from 'react';
import { IconComponent } from '@/components/IconComponent';
import type { OfUnion } from '@/types/common';
import type { MethodField } from '../helpers';
import { ScFieldBanner } from './styled';

export const FieldBanner: FC<
  OfUnion<MethodField>[Form.MethodFieldType.Banner]
> = ({ htmlContent, activeThemeMode }) => (
  <ScFieldBanner mode={activeThemeMode}>
    <IconComponent name="tooltipIcon" />
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  </ScFieldBanner>
);
